import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "app-navbar px-3 d-md-none position-sticky sticky-top d-flex flex-nowrap align-items-center justify-content-between shadow" }
const _hoisted_2 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 258.536 188.221",
  "svg-inline": '',
  class: /*#__PURE__*/_normalizeClass('me-3'),
  role: 'presentation',
  focusable: 'false',
  tabindex: '-1'
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M108.139 174.518c0 7.502-6.08 13.583-13.582 13.583-7.501 0-13.584-6.08-13.584-13.583 0-7.5 6.083-13.582 13.584-13.582 7.502 0 13.582 6.082 13.582 13.582zM40.75 160.936H13.585C6.083 160.936 0 167.018 0 174.518c0 7.502 6.083 13.583 13.585 13.583H40.75c7.503 0 13.581-6.08 13.581-13.583 0-7.5-6.078-13.582-13.58-13.582zm80.973-53.807H40.75c-7.501 0-13.584 6.083-13.584 13.582 0 7.502 6.082 13.583 13.584 13.583h80.973c7.502 0 13.581-6.08 13.581-13.583 0-7.5-6.078-13.582-13.58-13.582zM94.819 52.878H67.653c-7.502 0-13.585 6.083-13.585 13.583 0 7.502 6.083 13.583 13.585 13.583h27.166c7.502 0 13.581-6.08 13.581-13.583 0-7.5-6.079-13.583-13.581-13.583z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", { d: "M258.536 94.11c0-51.809-41.87-93.837-93.616-94.104V0h-70.1c-7.1 0-12.858 5.759-12.858 12.857 0 7.099 5.759 12.855 12.859 12.855h82.386c7.503 0 13.581 6.083 13.581 13.584 0 7.502-6.078 13.583-13.58 13.583h-28.319c-7.634 0-13.827 6.19-13.827 13.825 0 7.635 6.193 13.824 13.828 13.824h54.998c7.502 0 13.581 6.083 13.581 13.583 0 7.502-6.079 13.583-13.581 13.583H175.83l.001.013c-7.131.281-12.829 6.14-12.829 13.326 0 7.367 5.983 13.34 13.362 13.34h.843c7.503 0 13.581 6.084 13.581 13.584 0 7.502-6.078 13.583-13.58 13.583h-27.514v.016c-7.05.34-12.663 6.163-12.663 13.295 0 7.134 5.613 12.956 12.663 13.295v.017h11.685c.92.038 1.931.058 3.046.058 51.975 0 94.11-42.137 94.11-94.11z" }, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = {
  class: "navbar-toggler collapsed rounded px-2 py-1",
  type: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#app-sidebar",
  "aria-controls": "app-sidebar",
  "aria-expanded": "false",
  "aria-label": "Toggle navigation"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_vue_feather = _resolveComponent("vue-feather")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_router_link, {
      to: { name: 'start' },
      class: "navbar-brand align-items-center fw-semibold text-decoration-none"
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_5)),
        _createTextVNode("Admin panel")
      ]),
      _: 1
    }),
    _createElementVNode("button", _hoisted_6, [
      _createVNode(_component_vue_feather, {
        type: "menu",
        class: "align-text-bottom"
      })
    ])
  ]))
}